import { render, staticRenderFns } from "./NatureOfLossReview.vue?vue&type=template&id=9881546a&"
import script from "./NatureOfLossReview.vue?vue&type=script&lang=js&"
export * from "./NatureOfLossReview.vue?vue&type=script&lang=js&"
import style0 from "./NatureOfLossReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NatureOfLossReview.vue"
export default component.exports